import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CapmerComponent } from './capmer.component';

const routes: Routes = [
    {
        path: '',
        component: CapmerComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CapmerRoutingModule { }
